import { generatePath as _generatePath, matchPath } from 'react-router-dom';
import { store } from 'flow/configure-store';
import { State } from 'flow/types/State';
import { routes } from 'flow/types/routes';

/* Routes that render their own unauthenticated state, so a 401 must not throw the user out. */
export const isUnauthorizedSafePath = (pathname: string): boolean =>
    [routes.signin, routes.uaePassCallback].some(
        (path) => !!matchPath(pathname, { path, exact: true }),
    );

export const generatePath = (
    path: string,
    params: Record<string, string | number> = {},
) => {
    const state = store.getState() as State;
    params = { extensionKey: state.app.getIn(['extension', 'key']), ...params };

    return _generatePath(path, params);
};
